import gql from "graphql-tag";
import { taskServiceTypeDef } from "../definitions/task-service-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const updateMutation = gql`
  mutation update(
  $id: String!
  $callerName: String
  $callerPhone: String
  $carVin: String
  $carLicensePlate: String
  $carNonstandardLicensePlate: Boolean
  $carYearManufactured: Int
  $carModel: String
  $claimNumber: String
  $claimSettlementTypeId: String
  $clientName: String
  $clientPhone: String
  $clientType: String
  $clientIdentificationCode: String
  $excessPrice: Float
  $excessPercent: Float
  $dateOfLoss: Timestamp
  $damageNumber: String
  $description: String
  $externalCode: String
  $insuranceCompanyId: String
  $leasingApprovalNumber: String
  $note: String
  $serviceNumber: String
  $centralEventNumber: String
  ){
    task{
      update(input: {
        id: $id
        patch: {
          callerName: $callerName
          callerPhone: $callerPhone
          carVin: $carVin
          carLicensePlate: $carLicensePlate
          carNonstandardLicensePlate: $carNonstandardLicensePlate
          carYearManufactured: $carYearManufactured
          carModel: $carModel
          claimNumber: $claimNumber
          claimSettlementTypeId: $claimSettlementTypeId
          clientName: $clientName
          clientPhone: $clientPhone
          clientType: $clientType
          clientIdentificationCode: $clientIdentificationCode
          excessPrice: $excessPrice
          excessPercent: $excessPercent
          dateOfLoss: $dateOfLoss
          damageNumber: $damageNumber
          description: $description
          externalCode: $externalCode
          insuranceCompanyId: $insuranceCompanyId
          leasingApprovalNumber: $leasingApprovalNumber
          note: $note
          serviceNumber: $serviceNumber
          centralEventNumber: $centralEventNumber
        }
      }){
        output {
          ${taskServiceTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }

  }
`;

export default updateMutation;
